import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';

export function getAllPaused() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_GETALLPAUSED);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllPlanned() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_GETALLPLANNED);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getPlanned(top) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_GETPLANNED);
    url += `?top=${top}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function GetScannerDetail(id) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_GETSCANNERDETAIL);
    url += `?workflowId=${id}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function GetPickingDetail(id) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_GETPICKINGDETAIL);
    url += `?workflowId=${id}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function sendCarrierByBarcode(barCode) {

    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },

    };

    let url = apiHelper.ComposePickingUri(apiHelper.API_ACTION_SENDCARRIERBYBARCODE);
    url += `?barcode=${barCode}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
